import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const employeeList = styled.section`
  background: #fff;
  margin-top: 2rem;

  &:nth-child(2),
  &:nth-child(4) {
    background: #f3f3f3;
  }
  .infoCard {
    background: #fff;
    border-radius: 7px;
    flex: 0 calc(100% - 30px);
    width: calc(100% - 30px);

    @media (min-width: 520px) {
      flex: 0 calc(49% - 30px);
      width: calc(49% - 30px);
    }

    @media (min-width: 1024px) {
      flex: 0 calc(33% - 30px);
      width: calc(33% - 30px);
    }

    @media (min-width: 1280px) {
      flex: 0 calc(20.5% - 30px);
      width: calc(20.5% - 30px);
    }
  }
`;

const EmployeeImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  border-radius: 100%;

  img {
    border-radius: 100%;
  }
`;

const S = {
  employeeList,
  EmployeeImage,
};

export default S;
